export default "__VITE_ASSET__CERlhc1H__"